<!-- @format -->

@if (filteredNodes().courseUnitAttainmentCourseUnitIds.length > 0 || filteredNodes().customCourseUnitAttainmentIds.length > 0) {
  <ul class="sis-pb-xxs d-flex flex-wrap sis-pl-sm sis-pt-sm list-group-horizontal sis-plan-structure-attainment-node-structure-list">
    @for (courseUnitId of filteredNodes().courseUnitAttainmentCourseUnitIds; track courseUnitId) {
      <li class="list-group-item col-sm-12 col-md-6 col-lg-4">
        <div class="sis-mb-sm sis-mr-sm">
          <sis-plan-structure-course-unit
            [courseUnit]="planData.courseUnitsById[courseUnitId]"
            [planStateObject]="planStateObject"
            [headingLevel]="headingLevel"
            [planData]="planData">
          </sis-plan-structure-course-unit>
        </div>
      </li>
    }
    @for (customCourseUnitAttainmentId of filteredNodes().customCourseUnitAttainmentIds; track customCourseUnitAttainmentId) {
      <li class="list-group-item col-sm-12 col-md-6 col-lg-4">
        <div class="sis-mb-sm sis-mr-sm">
          <sis-plan-structure-custom-course-unit-attainment
            [customCourseUnitAttainment]="getCustomCourseUnitAttainment(customCourseUnitAttainmentId)"
            [planStateObject]="planStateObject"
            [headingLevel]="headingLevel">
          </sis-plan-structure-custom-course-unit-attainment>
        </div>
      </li>
    }
  </ul>
}
@for (moduleId of filteredNodes().moduleAttainmentModuleIds; track moduleId) {
  <sis-plan-structure-module
    [module]="getModule(moduleId)"
    [planStateObject]="planStateObject"
    [planData]="planData"
    [headingLevel]="headingLevel">
  </sis-plan-structure-module>
}
@for (customModuleAttainmentId of filteredNodes().customModuleAttainmentIds; track customModuleAttainmentId) {
  <sis-plan-structure-custom-module-attainment
    [customModuleAttainment]="getCustomModuleAttainment(customModuleAttainmentId)"
    [planStateObject]="planStateObject"
    [planData]="planData"
    [headingLevel]="headingLevel">
  </sis-plan-structure-custom-module-attainment>
}
@for (attainmentGroupNode of filteredNodes().attainmentGroupNodes; track attainmentGroupNode) {
  <sis-plan-structure-attainment-group-node
    [attainmentGroupNode]="attainmentGroupNode"
    [planStateObject]="planStateObject"
    [planData]="planData"
    [headingLevel]="headingLevel">
  </sis-plan-structure-attainment-group-node>
}
